module.exports = __webpack_public_path__ + "img/battery.3290ff08.svg";